// IMPORTS ****************************************************************************************
// ************************************************************************************************
import { ApiApplyWizardStepList, ApiApplyWizardStepListOk } from 'src/types/v1-api-types';


// Step list languages ************************************************************************************
// pathname: /v1/apply-wizard/{jobId}/step-list
// ************************************************************************************************
export const isApplyWizardStepListOk = (res: ApiApplyWizardStepList | void): res is ApiApplyWizardStepListOk => res !== undefined && res !== null
  && (res as ApiApplyWizardStepListOk)?.length >= 0;
